import React from "react";
import "./UserFeedbackHeader.css";

const UserFeedBackHeader = () => {
  return (
    <section className="UserFeedBackHeader-container">
      <div className="UserFeedBackHeader-overlay">
        <div className="container" style={{ textAlign: "center" }}>
          <h1 className="UserFeedBackHeader-title">Client FeedBack</h1>
          <div className="UserFeedBackHeader-breadcrumb">
            <button
              className="btn"
              style={{ backgroundColor: "#04143B", color: "#fff" }}
            >
              Home - Client FeedBack
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserFeedBackHeader;
